import React from "react";
import LinkExistingContact from "./LinkExistingContact";
import NewContact from "./NewContact";
import { ChooseContactRadio } from "./ChooseContactRadio";

interface Props {
  company: server.dto.CompanySmall
  selectedContact: server.dto.ContactSmallV2
  onContactChanged: (contact: server.dto.ContactSmallV2) => void
}

const ChooseContact = (props: Props) => {
  const [contactOptions, setContactOptions] = React.useState<server.dto.ContactSmallV2[]>(props.selectedContact ? [props.selectedContact] : []);

  const refreshContacts = async () => {
    const instruction: server.dto.ListContactByCompanyInstruction = {
      companyId: props.company.companyId,
      page: 1,
      perPage: 1000,
      isActive: true
    };

    return window.CoreApi.CompanyToContact.ListContactByCompany(instruction)
      .then(res => {
        const contacts = res.data.data.map(item => item.contact);

        if (props.selectedContact != null && !contacts.some(c => c.contactId === props.selectedContact.contactId)) {
          // Sometimes the selected contact won't appear in the list of linked contacts
          // For example, if the contact company relationship isn't active anymore (e.g. because the company was deleted)
          // But we still want to have the selected contact in this list
          setContactOptions([...contacts, props.selectedContact]);
        } else {
          setContactOptions(contacts);
        }

        return contacts;
      });
  };

  React.useEffect(() => {
    refreshContacts();
  }, []);

  const onContactSelected = (contact: server.dto.ContactSmallV2 | null) => {
    props.onContactChanged(contact);
  };

  const onContactLinked = async (contactId: number) => {
    const instruction: server.dto.SetCompanyToContactLinkInstruction = {
      companyId: props.company.companyId,
      contactId,
      isActive: true,
      defaultSelect: false
    };
    const res = await window.CoreApi.CompanyToContact.SetLink(instruction);
    if (res.data.hasErrors) {
      window.displayGenericModal("Error", res.data.errors[0].message, "tiny", "red");
      return;
    }
    const contacts = await refreshContacts();
    const contact = contacts.find(c => c.contactId === contactId);

    props.onContactChanged(contact);
  };

  const onContactCreated = async (newContactId: number) => {
    return onContactLinked(newContactId);
  };

  const canEditContacts = site.permissions.addressBook.canCreate;

  return <div className="flex-column gap">
    <div className="itemchooserTable">
      <ChooseContactRadio
        contactOptions={contactOptions}
        selectedContact={props.selectedContact}
        onContactSelected={onContactSelected}
        onContactEdited={refreshContacts}
      />
    </div>
    {canEditContacts && <div>
      <LinkExistingContact
        onContactLinked={onContactLinked}
      />
      <NewContact
        onContactCreated={onContactCreated}
      />
    </div>}
  </div>;
};

export default ChooseContact;